import { useCallback, useEffect, useState } from 'react'

import { get } from '../../utils/api'
import { handleApiErrors } from '../../utils/apiErrors'
import { UserLevel } from './definitions'
import { defaultSettings } from './SettingsContext'
import { SettingResults, Settings } from './types'

const useSettings = () => {
  const [settings, setSettings] = useState<Settings | undefined>(undefined)
  const [isFetching, setFetching] = useState(false)

  const parseSettings = (newSettings: SettingResults) => {
    const parsedSettings: Settings = { ...defaultSettings }

    newSettings.results.forEach((setting) => {
      switch (setting.identifier) {
        case 'notification__email_enabled':
          parsedSettings.notification__email_enabled = setting.value as boolean
          break
        case 'notification__email':
          parsedSettings.notification__email = setting.value as string
          break
        case 'preference__user_language':
          parsedSettings.preference__user_language = setting.value as string
          break
        case 'preference__user_level':
          parsedSettings.preference__user_level = setting.value as UserLevel
          break
        case 'preference__show_annotator_instructions':
          parsedSettings.preference__show_annotator_instructions = setting.value as boolean
          break
        case 'preference__show_guided_tour':
          parsedSettings.preference__show_guided_tour = setting.value as boolean
          break
        case 'preference__show_precision_alert_on_creation':
          parsedSettings.preference__show_precision_alert_on_creation = setting.value as boolean
          break
        case 'preference__show_precision_alert_on_download':
          parsedSettings.preference__show_precision_alert_on_download = setting.value as boolean
          break
        default:
          break
      }
    })

    return parsedSettings
  }

  const fetchSettings = useCallback(() => {
    setFetching(true)
    return new Promise<SettingResults>((resolve, reject) => {
      get<SettingResults>(`/settings/?limit=50`)
        .then((data) => {
          resolve(data)
          setSettings(parseSettings(data))
          setFetching(false)
        })
        .catch((err) => {
          reject(err)
          setFetching(false)
          handleApiErrors(err)
        })
    })
  }, [])

  useEffect(() => {
    fetchSettings()
  }, [fetchSettings])

  return { settings, isFetching }
}

export default useSettings
